import { broadcastResponseToMainFrame } from '@azure/msal-browser/redirect-bridge';

function isAuthResponse(parameters) {
  return parameters.has('state') && (parameters.has('code') || parameters.has('error'));
}

/**
 * Hands an Entra response at the registered redirect URI to MSAL's redirect bridge instead of booting the app.
 *
 * MSAL v5 completes hidden-iframe token renewal only when the redirect page broadcasts the response back,
 * and caches full-page redirect responses before returning to the page that started the sign-in.
 *
 * @returns true when the page held an authentication response and the bridge handled it.
 */
export async function handleAuthRedirect(broadcastResponse = broadcastResponseToMainFrame) {
  const url = new URL(window.location.href);
  const fragment = new URLSearchParams(url.hash.replace(/^#/, ''));

  if (isAuthResponse(fragment) || isAuthResponse(url.searchParams)) {
    await broadcastResponse();
    return true;
  } else {
    return false;
  }
}
